import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCurrentTV } from '../../../../action/tvChannelAction'
import { withTranslation } from "react-i18next";
import { setGoHome, setLoginRequired } from '../../../action/homeAction';
import { getTvLiftStatus, setTvLiftStatus } from '../../../../action/roomControlAction';
import tvLogo from "./assets/tvLogo.svg"
import { closeOrderPopUp } from '../../../action/hCommerce2';
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility';
import { guestDetails, sendAnalytics } from '../../../../action/homeAction';
import { CLICKED, EXIT } from '../../../../config/constant';
import Loader from '../../../UI/loader';
import { wipeGuestData } from '../../../../JS/wipeGuestData';
import { CMSPath } from "../../../../config/constant";
import { ArrowDown, ArrowUp } from '../assets/ControllButtonIcons';


class TVLift extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidget.displayName,
            selectedTVData: null,
            showLoader: false,
        }
    }

    componentWillUnmount() {
        // Send Analytics
        if (this.props.guestIsLoggedIn) {
            console.log("sending analytics")
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second')
            let label = getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" })
            this.props.sendAnalytics(
                this.props.guestDetail,
                this.state.widgetName,
                EXIT,
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration },
                0,
                this.props.guestIsLoggedIn
            );
        }
        // 
    }

    componentDidMount() {
        let locationId = localStorage.getItem("roomID")


        if(this.props.stopCompDidMound) return;

        if (this.props.guestIsLoggedIn) {

            this.setState({ showLoader: true })
            this.props.getTvLiftStatus(locationId, (status) => {
                console.log("TV status", status)
                this.setState({ showLoader: false })
            });

             // Send Analytics
            let label = getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" })
            this.props.sendAnalytics(
                this.props.guestDetail,
                this.props.currentWidget.displayName,
                CLICKED,
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                this.props.guestIsLoggedIn
            );
        } else {
            this.props.setLoginRequired(true)
        }
        // 
    }

    sendCommand = (command) => {
        let locationId = localStorage.getItem("roomID")
        this.props.setTvLiftStatus(locationId, command, this.state.selectedTVData.uniqueKey, (status, msg) => {
            if (!status) this.props.closeOrderPopUp(true, msg, "", true)
        })
    }

    onTVSelect = (TVdata) => {
        this.setState({ selectedTVData: TVdata })
    }

    render() {
        const { t } = this.props
        return (
                        this.props.OnHomeScreen ? 
                    this.props.TVdata ?     
                    <div class="room-control-list">
                    <div class="room-control-item">
                    <div class="room-control-item-label">TV Lift</div>
                        <div class="room-control-buttons">
                            <button  onClick={ ()=>{
                                this.setState({ selectedTVData: this.props.TVdata })
                                this.sendCommand("tvLiftMoveDown") 
                            }}>
                                <ArrowDown/>
                                </button>
                            <button onClick={ ()=>{
                                this.setState({ selectedTVData: this.props.TVdata })
                                this.sendCommand("tvLiftMoveUp")
                            }
                            }>
                                <ArrowUp/>
                                </button>
                        </div>
                    </div>
            </div>
            :
            <p>No TV data found</p> 
            :
            <div class="main-container">
                <header class="inner-pages w-footer subpages" style={{
                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                }}>
                    <a onClick={() => this.props.setGoHome(true)} class="button-back"></a>
                    <div class="heading align-center">
                        <p class="bold" style={{
                            color: this.props.menuColor.assetFontSelectorColor,
                            textShadow: "unset"
                        }}>TV Lift</p>
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                    </div>
                </header>
                <section id="tvLift" class="widgets margin-0 padding-top-1 container-bg">
                    {this.props.tVLiftList.length > 0 ?
                        < div class="widgets">
                            {
                                this.props.tVLiftList.map((iterator, index) => {
                                    return (
                                        <div class="tv-lift selected">
                                            <div class="lift-tv-label">{iterator.label}</div>
                                            <div class={`lift-center ${this.state.selectedTVData && this.state.selectedTVData.uniqueKey == iterator.uniqueKey ? "selected" : ""}`}>
                                                <div class="lift-up lift-nav" onClick={this.state.selectedTVData && this.state.selectedTVData.uniqueKey == iterator.uniqueKey ? () => this.sendCommand("tvLiftMoveUp") : null}>
                                                    <a leaSpeakerData class="button focusable"></a>
                                                </div>
                                                <div class="lift-mid">
                                                    <div class="lift-tv-container" onClick={() => this.setState({ selectedTVData: iterator })}>
                                                        <div class="lift-label label-top">Reveal TV</div>
                                                        <div class="lift-label label-mid">Press here to select the TV</div>
                                                        <img src={tvLogo} alt="TV" />
                                                        <div class="lift-label label-bottom">Stow TV</div>
                                                    </div>
                                                </div>
                                                <div class="lift-down lift-nav" onClick={this.state.selectedTVData && this.state.selectedTVData.uniqueKey == iterator.uniqueKey ? () => this.sendCommand("tvLiftMoveDown") : null}>
                                                    <a leaSpeakerData class="button focusable"></a>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div> :
                        <div>
                            {t('room_control.tv_control.no_tv_txt')}
                        </div>
                    }
                </section>

                {this.state.showLoader && <Loader displayMsg={"Fecthing data..."} />}

            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidget: state.store.sideNavBar.currentWidget,
        menuColor: state.store.home.MenuColor,
        tVLiftList: state.store.tVLiftList,
        currentHomePage: state.store2.currentHomePage,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    }
}
export default connect(
    mapStateToProps,
    {
        setCurrentTV,
        setGoHome,
        getTvLiftStatus,
        setTvLiftStatus,
        closeOrderPopUp,
        sendAnalytics,
        setLoginRequired,
        guestDetails
    }
)(withTranslation('translations')(TVLift));